import {
  ActionReducerMapBuilder,
  createSlice,
  CreateSliceOptions
} from '@reduxjs/toolkit'

import { INITIAL_STATE } from './TYPES'

import { getCustomerProfileDetailsActions } from '~/src/Redux/Customer/Actions'
import { SLICE_NAME } from '~/src/Redux/Customer/Selectors'

const sliceOptions: CreateSliceOptions = {
  name: SLICE_NAME,
  initialState: INITIAL_STATE,
  reducers: {},
  extraReducers: (builder: ActionReducerMapBuilder<any>): void => {
    builder.addCase(
      getCustomerProfileDetailsActions.success,
      (state, { payload }) => {
        state.customerProfile = payload
      }
    )
  }
}

const slice = createSlice(sliceOptions)

export default slice.reducer
